"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Alert;

require("core-js/modules/web.dom-collections.iterator.js");

var _AlertModule = _interopRequireDefault(require("../../assets/styles/components/Alert.module.scss"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Alert(_ref) {
  let {
    type = "info",
    children,
    title,
    action,
    animateIn = "",
    animateOut = "",
    onClick,
    reset
  } = _ref;
  //ANIMATIONS
  //SwipeInRight
  //SwipeOutRight
  //SwipeInBottom
  //SwipeOutBottom
  //FadeIn
  //FadeOut
  //BounceIn
  //BounceOut
  const [animateout_state, setanimateout_state] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setanimateout_state(false);
  }, []);
  (0, _react.useEffect)(() => {
    if (reset) {
      setanimateout_state(false);
    }
  }, [reset]);

  const startAnimateOut = e => {
    setanimateout_state(true);
    onClick(e);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _AlertModule.default.ani,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "\n                ".concat(animateout_state && animateOut === "SwipeOutRight" ? _AlertModule.default.animation_swipeoutright : animateout_state && animateOut === "SwipeOutBottom" ? _AlertModule.default.animation_swipeoutbottom : animateout_state && animateOut === "FadeOut" ? _AlertModule.default.animation_fadeout : animateout_state && animateOut === "BounceOut" ? _AlertModule.default.animation_bounceout : "", "\n                ").concat(animateIn === "SwipeInRight" ? _AlertModule.default.animation_swipeinright : animateIn === "SwipeInBottom" ? _AlertModule.default.animation_swipeinbottom : animateIn === "FadeIn" ? _AlertModule.default.animation_fadein : animateIn === "BounceIn" ? _AlertModule.default.animation_bouncein : "", "\n                ").concat(_AlertModule.default.alert, "\n                ").concat(type === "info" ? _AlertModule.default.type_info : type === "warning" ? _AlertModule.default.type_warning : type === "error" ? _AlertModule.default.type_error : type === "success" ? _AlertModule.default.type_success : _AlertModule.default.type_info, "\n            "),
      children: [type === "error" && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _AlertModule.default.icon,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
          focusable: "false",
          "aria-hidden": "true",
          viewBox: "0 0 24 24",
          "data-testid": "ErrorOutlineIcon",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
          })
        })
      }), type === "warning" && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _AlertModule.default.icon,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
          focusable: "false",
          "aria-hidden": "true",
          viewBox: "0 0 24 24",
          "data-testid": "ReportProblemOutlinedIcon",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
          })
        })
      }), type === "info" && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _AlertModule.default.icon,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
          focusable: "false",
          "aria-hidden": "true",
          viewBox: "0 0 24 24",
          "data-testid": "InfoOutlinedIcon",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
          })
        })
      }), type === "success" && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _AlertModule.default.icon,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
          focusable: "false",
          "aria-hidden": "true",
          viewBox: "0 0 24 24",
          "data-testid": "SuccessOutlinedIcon",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _AlertModule.default.alert_container,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _AlertModule.default.alert_content,
          children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: _AlertModule.default.title,
            children: title
          }), children]
        }), action === "close" && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: e => {
            startAnimateOut(e);
          },
          className: _AlertModule.default.close_button,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
            focusable: "false",
            "aria-hidden": "true",
            viewBox: "0 0 24 24",
            "data-testid": "CloseIcon",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            })
          })
        }), action === "ok" && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: e => {
            startAnimateOut(e);
          },
          className: _AlertModule.default.ok_button,
          children: "OK"
        }), action !== "close" && action !== "ok" && action && action]
      })]
    })
  });
}